/**
 * Меню преподавателя в шапке и плашки на главной.
 * В навигации только ежедневная работа; остальное — на главной.
 */

export function getTeacherNavItems() {
  return [
    {
      id: 'schedule',
      label: 'Расписание',
      icon: 'fa-calendar-days',
      to: '/teacher/schedule',
    },
    {
      id: 'students',
      label: 'Ученики',
      icon: 'fa-user-group',
      to: '/teacher',
      end: true,
      match: (pathname) => pathname === '/teacher' || pathname.startsWith('/teacher/students'),
    },
    {
      id: 'billing',
      label: 'Оплата',
      icon: 'fa-wallet',
      to: '/teacher/billing',
    },
    {
      id: 'messages',
      label: 'Сообщения',
      icon: 'fa-envelope',
      to: '/teacher/messages',
    },
    {
      id: 'lists',
      label: 'Списки',
      icon: 'fa-list-check',
      to: '/teacher/lists',
      title: 'Списки, выданные ученикам',
      match: (pathname) => pathname.startsWith('/teacher/lists'),
    },
  ];
}

export function getTeacherHomeItems({
  user,
  topicPrograms = [],
  newUsersUnread = 0,
} = {}) {
  const collabTo = user?.collab_session_id
    ? `/collaborative/${user.collab_session_id}`
    : '/collaborative';
  const isSiteAdmin = Boolean(user?.is_staff || user?.is_admin);

  const items = [
    {
      id: 'quizzes',
      label: 'Тесты',
      icon: 'fa-clipboard-check',
      to: '/practice-quizzes',
    },
    {
      id: 'trainers',
      label: 'Тренажёры',
      icon: 'fa-bullseye',
      to: '/trainers',
    },
    {
      id: 'articles',
      label: 'Статьи',
      icon: 'fa-newspaper',
      to: '/articles',
    },
    {
      id: 'konspekt',
      label: 'Конспект',
      icon: 'fa-book',
      to: '/konspekty',
    },
    {
      id: 'collab',
      label: 'Совместное кодирование',
      icon: 'fa-code',
      to: collabTo,
    },
    {
      id: 'lessons',
      label: 'Уроки',
      icon: 'fa-chalkboard-user',
      to: '/teacher/lessons',
    },
    {
      id: 'tools',
      label: 'Инструменты',
      icon: 'fa-screwdriver-wrench',
      to: '/teacher/tools',
    },
    {
      id: 'task-inbox',
      label: 'Очередь задач',
      icon: 'fa-inbox',
      to: '/teacher/task-inbox',
    },
    {
      id: 'catalog',
      label: 'Каталог задач',
      icon: 'fa-book-open',
      to: '/catalog',
    },
    {
      id: 'tags',
      label: 'Теги',
      icon: 'fa-tags',
      to: '/teacher/tags',
    },
  ];

  if (isSiteAdmin) {
    items.push({
      id: 'new-users',
      label: newUsersUnread > 0
        ? `Новые пользователи (${newUsersUnread})`
        : 'Новые пользователи',
      icon: 'fa-user-plus',
      to: '/teacher/new-users',
    });
    items.push({
      id: 'all-users',
      label: 'Пользователи',
      icon: 'fa-users',
      to: '/teacher/users',
    });
  }

  if (user?.is_parent) {
    items.push({
      id: 'parent',
      label: 'Дети',
      icon: 'fa-children',
      to: '/parent',
    });
  }

  for (const p of topicPrograms) {
    items.push({
      id: `theme-${p.slug}`,
      label: p.label || p.slug,
      icon: 'fa-graduation-cap',
      to: `/themes/${p.slug}`,
    });
  }

  return items;
}
